import { BarChart as RechartsBarChart } from 'recharts';

export const BarChart = (
    props: React.ComponentProps<typeof RechartsBarChart>
) => {
    return (
        <RechartsBarChart data-testid={'BarChart-container'} {...props} />
    );
};

export default BarChart;
